module.exports = __webpack_public_path__ + "static/media/banner-img-wrp-img-3.b3c75d5a.png";